<h1 mat-dialog-title i18n="@@shared.about.title">About Tailormap</h1>

<ng-template #infoOrUnknown let-infoText>
  @if (infoText) {
    {{infoText}}
  }
  @if (!infoText) {
    <ng-container i18n="@@shared.about.unknown">Unknown</ng-container>
  }
</ng-template>

<div class="dialog-content">
  @if (loading$ | async) {
    <mat-spinner mode="indeterminate" diameter="20" color="primary"></mat-spinner>
  }
  @if (version$ | async; as version) {
    <div class="row">
      <h2 class="label" i18n="@@shared.about.version">Version</h2>
      <div><ng-container *ngTemplateOutlet="infoOrUnknown; context: {$implicit: version.version}"></ng-container></div>
    </div>
    <div class="row">
      <h2 class="label" i18n="@@shared.about.build-date">Build date</h2>
      <div>
        @if (version.buildDate) {
          <span>{{version.buildDate | date:"mediumDate" }}</span>&nbsp;
          <span>{{version.buildDate | date:"mediumTime" }}</span>
        }
        @if (!version.buildDate) {
          <ng-container i18n="@@shared.about.unknown">Unknown</ng-container>
        }
      </div>
    </div>
    @if (version.addedPackages.length > 0) {
      <div class="row">
        <h2 class="label" i18n="@@shared.about.added-packages">Extensions</h2>
        <div>
          @for (pkg of version.addedPackages; track pkg) {
            <div>
              {{pkg.name}} {{pkg.version}}
            </div>
          }
        </div>
      </div>
    }
  }
</div>

<div align="end" mat-dialog-actions>
  <button (click)="close()" color="primary" i18n="@@shared.common.close" mat-flat-button>Close</button>
</div>
